<div class="ds-top-bar-example">
  <div class="ds-footer__logo">
    <a routerLink="/dashboard">
      <img src="/assets/images/logoSnam.svg" alt="Logo SNAM" />
    </a>
  </div>
  <span
    class="ds-top-bar-example__label   ff-body-m ff-regular"
    style="white-space: nowrap"
    >Edith</span
  >

  <div class="ds-top-bar-example__container-icon">
    @if (showToggle) {
      <ds-switch
        switch-states="two"
        switch-label-left=""
        switch-label-right=""
        switch-icon-left="icon-user"
        switch-icon-right="icon-group-user"
        switch-size="small"
        checked-button="left"
        [attr.button-left-aria-label]="
          isTeamView
            ? ('userStr' | translate)
            : ('userStr' | translate | uppercase)
        "
        [attr.button-right-aria-label]="
          isTeamView
            ? ('teamStr' | translate | uppercase)
            : ('teamStr' | translate)
        "
        switch-left-id="switchLeftId"
        switch-right-id="switchRightId"
        (onSwitchChange)="onSwitchChange($event)"></ds-switch>
      <div
        class="ds-dividers ds-dividers--thin ds-dividers--center_solid ds-dividers--vertical m-0"></div>
    }

    <div
      class="ds-top-bar-v2-header__bell-icon m-0 d-flex"
      (click)="toggle('notificationPanelId')"
      (keydown.enter)="toggle('notificationPanelId')">
      <ds-tooltip-trigger
        [attr.tooltip-position]="'bottom'"
        [attr.tooltip-text]="messageNotification"
        [attr.z-index]="999"
        [attr.aria-described-by]="'notificationBadge'">
        <ds-icon
          icon="icon-notification"
          icon-size="medium"
          id="notificationIcon"></ds-icon>
        <ds-notification-badge
          id="notificationBadge"
          is-small="true"
          [style.visibility]="myPanelData.length ? 'visible' : 'hidden'"
          [attr.notification-status]="'error'"
          [attr.badge-aria-label]="messageNotification"></ds-notification-badge>
      </ds-tooltip-trigger>
    </div>

    <ds-notification-panel
      #notificationPanel
      class="hidden notification-panel"
      style="display: none"
      id="notificationPanelId"
      [isExternalTextlink]="false"
      [isRouterTextlink]="true"
      [textlinkUrl]="'notifiche'"
      [panelData]="myPanelData"
      [attr.panel-title]="'notifiche.title' | translate"
      [attr.panel-empty-text]="'notifiche.noNotifiche' | translate"
      [attr.label-today]="'notifiche.oggi' | translate"
      [attr.label-yesterday]="'notifiche.ieri' | translate"
      [attr.textlink-text]="'notifiche.mostraTutte' | translate"
      [attr.action-menu-title]="'notifiche.azioni' | translate"
      [attr.textlink-aria-label]="'notifiche.mostraTutteLabel' | translate"
      [attr.action-menu-aria-label]="'notifiche.listaAzioni' | translate"
      [attr.new-notification-aria-label]="'notifiche.nuovaNotifica' | translate"
      [attr.close-button-aria-label]="
        'notifiche.ariaLabelChiudiPannello' | translate
      "
      [attr.close-action-menu-button-aria-label]="
        'notifiche.ariaLabelChiusuraMenuAzioni' | translate
      "
      [attr.has-textlink-animation]="false"
      (onClickCloseIcon)="toggle('notificationPanelId')"
      (onClickLink)="onShowAll($event)"></ds-notification-panel>

    <div
      class="ds-dividers ds-dividers--thin ds-dividers--center_solid ds-dividers--vertical m-0"></div>
    <div
      class="ds-top-bar-example__container-user"
      (click)="toggle('profileMenuId')"
      (keydown.enter)="toggle('profileMenuId')">
      <ds-avatar
        avatar-type="initial"
        [attr.full-name]="fullname"
        avatar-size="small"
        is-group-variant=""
        is-number-variant=""
        class="ds-top-bar-example__container-text m-0"></ds-avatar>
      <div class="ds-top-bar-example__container-text">
        <span
          class="  ff-body-m ff-regular"
          style="color: var(--text-reading-1)"
          >{{ fullname }}</span
        >
        <span
          class="  ff-body-xs ff-regular"
          style="color: var(--text-placeholder)"
          >{{ user?.RIDP }}</span
        >
      </div>
    </div>
    <ds-icon
      id="arrowTopBar"
      [attr.icon]="'icon-chevron-down'"
      [attr.icon-size]="'medium'"
      [attr.icon-filled]="false"
      (click)="toggle('profileMenuId')"
      (keydown.enter)="toggle('profileMenuId')"
      tabindex="0"></ds-icon>
    <ds-profile-menu
      class="hidden"
      id="profileMenuId"
      [attr.menu-title]="'langSel' | translate"
      [attr.has-back-button]="true"
      [attr.has-textlink-animation]="true"
      [menuItems]="myProfileMenuItemsConfig"
      (onClickLink)="onClickLanguages($event)"></ds-profile-menu>
  </div>
</div>
